export const UPDATE_SELECTED_DATE_RANGE = 'UPDATE_SELECTED_DATE_RANGE';

function updateSelectedDateRange(type, startDate, endDate) {
    return {
        type: UPDATE_SELECTED_DATE_RANGE,
        payload: {
            type,
            startDate,
            endDate
        }
    };
}


export default {
    updateSelectedDateRange
};



// WEBPACK FOOTER //
// ./components/date-picker/date-picker-actions.js